import { render } from "./ImpressumIndex.vue?vue&type=template&id=e6f9eee6&scoped=true"
import script from "./ImpressumIndex.vue?vue&type=script&lang=js"
export * from "./ImpressumIndex.vue?vue&type=script&lang=js"

import "./ImpressumIndex.vue?vue&type=style&index=0&id=e6f9eee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f9eee6"]])

export default __exports__